import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeftNavComponent } from './left-nav.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [LeftNavComponent],
  imports: [CommonModule, MatIconModule],
  exports: [LeftNavComponent]
})
export class LeftNavModule {}
